var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "multiselect",
    {
      attrs: {
        "track-by": "id",
        placeholder: _vm.placeholder,
        multiple: true,
        options: _vm.availableChannels,
        searchable: true,
        "allow-empty": true,
        "preserve-search": true,
        "show-labels": false,
        hideSelected: true,
        clearOnSelect: true,
        closeOnSelect: true,
        "internal-search": false,
        loading: _vm.isLoading,
        max: _vm.maxChannels,
        showNoOptions: true,
        showNoResult: true,
        disabled: _vm.disabled,
      },
      on: { "search-change": _vm.onSearch },
      scopedSlots: _vm._u([
        {
          key: "option",
          fn: function (ref) {
            var option = ref.option
            return [
              _c("div", { staticClass: "watchman-option" }, [
                _c("strong", [_vm._v(_vm._s(option.watchman.name))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "display-flex text-truncate" },
                  [
                    _c("ChannelIcon", {
                      class: _vm.validationStatusColor(option),
                      attrs: { type: option.type },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-mono ml-1" }, [
                      _vm._v(_vm._s(option.value)),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          },
        },
        {
          key: "tag",
          fn: function (ref) {
            var option = ref.option
            var remove = ref.remove
            var ChannelIcon = ref.ChannelIcon
            return [
              _c("div", { staticClass: "watchman-selected multiselect__tag" }, [
                _c("div", { staticClass: "head" }, [
                  _c("span", { staticClass: "name text-truncate pr-2" }, [
                    _vm._v(_vm._s(option.watchman.name)),
                  ]),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "ml-auto",
                    attrs: { "aria-label": "remove", type: "text" },
                    on: {
                      click: function ($event) {
                        return remove(option)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "display-flex text-truncate watchman-value",
                    attrs: { title: option.value },
                  },
                  [
                    _c("ChannelIcon", {
                      class: _vm.validationStatusColor(option),
                      attrs: { type: option.type },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-mono ml-1" }, [
                      _vm._v(_vm._s(option.value)),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.selectedChannels,
        callback: function ($$v) {
          _vm.selectedChannels = $$v
        },
        expression: "selectedChannels",
      },
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("template", { slot: "maxElements" }, [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("profile.form.select_max_options", {
                max: _vm.maxChannels,
              })
            ),
          },
        }),
      ]),
      _vm._v(" "),
      _c("template", { slot: "noResult" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("profile.form.select_no_results")))]),
      ]),
      _vm._v(" "),
      _c("template", { slot: "noOptions" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("profile.form.select_no_results")))]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }